import Log from "app/utils/log";
import RegUiClient from "reg-ui-client";

const log = new Log("BvpRegUiClient");

let regUiClient = null;

export default {
    getAndInitializeRegUiClient() {
        try {
            if (!regUiClient) {
                regUiClient = new RegUiClient([]);
                regUiClient.initialize();
            }

            return regUiClient;
        } catch (e) {
            log.info("Error initializing reg-ui-client.", e);
            return null;
        }
    },
    // for testing purpose
    _resetRegUiClient(val) {
        regUiClient = val;
    }
};
